import { CommonErrorsKey } from "."
import { GlobalError } from "./GlobalError"

type Data = {
  data: {
    errorName: string
  }
  cause: Data
}

export class UnknownError extends GlobalError {
  rawError: Error
  keyReason: string

  constructor(keyReason: string, message: string, rawError?: Error) {
    console.log(keyReason, message, rawError)
    super(CommonErrorsKey.UnknownError, message)
    this.rawError = rawError || new Error(CommonErrorsKey.UnknownError)

    this.keyReason = keyReason
    // We try to extract the key
    const cause: Data = rawError?.cause as unknown as Data
    if (cause?.data?.errorName) {
      this.keyReason = cause.data?.errorName
    } else if (cause?.cause?.data?.errorName) {
      this.keyReason = cause?.cause?.data?.errorName
    }
  }
}
